import { CautionsTabAssociatedPersonsView } from '@mark43/cad-api';
import { TabSection } from '../../../../../panels/entity-panels/tabs/tab-section';
import { AssociatedPersonsCommonContent } from './associated-persons-common-content';
import { useApplicationType } from '../../../../../common/hooks/use-application-type';

export const AssociatedPersonsSection = ({
    data,
    isLoading,
}: {
    data: CautionsTabAssociatedPersonsView | undefined;
    isLoading: boolean;
}) => {
    const { isFirstResponder } = useApplicationType();

    if (isFirstResponder) {
        return <AssociatedPersonsCommonContent data={data} />;
    }

    return (
        <TabSection
            loading={isLoading}
            title={`Associated Persons${data?.personsCount ? ` (${data?.personsCount})` : ''}`}
            emptyText="No Associated Persons Found"
            testId="ASSOCIATED_PERSONS"
        >
            {!!data?.cautionsTabAssociatedPeople?.length && (
                <AssociatedPersonsCommonContent data={data} />
            )}
        </TabSection>
    );
};
